import { styled, Theme } from "@mui/material";

export const flexGap = (theme: Theme) => ({
    display: "flex",
    gap: theme.spacing(1),
});

export const LabelContainer = styled("div")(({ theme }) => ({
    ...flexGap(theme),
}));
